import React from 'react';
import PropTypes from 'prop-types';

import {
    TopToolbar,
    ListButton,
    useResourceDefinition,
} from 'react-admin';

const CreateActions = (props) => {
    const { className, hasList: propHasList } = props;
    const { hasList } = useResourceDefinition(props);

    const shouldShowList = propHasList || hasList;

    return (
        <TopToolbar className={className}>
            { shouldShowList ? <ListButton /> : null}
        </TopToolbar>
    );
};

CreateActions.propTypes = {
    className: PropTypes.string,
    hasList: PropTypes.bool,
};

export default CreateActions;
